<template>
  <div class="register-page">
    <el-card class="register-card">
      <template #header>
        <div class="card-header">
          <h2>教师注册</h2>
          <p class="register-system-title">
            <span class="brand-love">爱教务</span><span class="brand-sub">智能教务系统</span> - 教师自助通道
          </p>
        </div>
      </template>

      <el-form :model="form" :rules="rules" ref="registerFormRef" label-position="top" @submit.prevent="handleRegister">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="form.username" placeholder="请输入用户名（至少 3 位）" autocomplete="username" />
        </el-form-item>

        <el-form-item label="密码" prop="password">
          <el-input
            v-model="form.password"
            type="password"
            placeholder="请输入密码（至少 6 位）"
            show-password
            autocomplete="new-password"
          />
        </el-form-item>

        <el-form-item label="手机号" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入手机号" autocomplete="tel" />
        </el-form-item>

        <el-form-item label="所属学校" prop="school">
          <el-input v-model="form.school" placeholder="请输入所属学校全称" />
        </el-form-item>

        <el-button class="register-btn" type="primary" :loading="loading" @click="handleRegister">
          注册
        </el-button>
        <div class="login-link">
          已有账号？<el-link type="primary" @click="router.push('/login')">立即登录</el-link>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { authApi } from '@/api'

const router = useRouter()
const loading = ref(false)
const registerFormRef = ref(null)

const form = reactive({
  username: '',
  password: '',
  school: '',
  phone: ''
})

const validatePhone = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请输入手机号'))
  } else if (!/^1[3-9]\d{9}$/.test(value)) {
    callback(new Error('手机号格式不正确'))
  } else {
    callback()
  }
}

const rules = {
  username: [
    { required: true, message: '请输入用户名', trigger: 'blur' },
    { min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur' }
  ],
  password: [
    { required: true, message: '请输入密码', trigger: 'blur' },
    { min: 6, max: 128, message: '密码不能少于 6 位', trigger: 'blur' }
  ],
  school: [
    { required: true, message: '请输入所属学校', trigger: 'blur' },
    { min: 2, max: 100, message: '学校名称长度至少 2 位', trigger: 'blur' }
  ],
  phone: [
    { required: true, message: '请输入手机号', trigger: 'blur' },
    { validator: validatePhone, trigger: 'blur' }
  ]
}

const handleRegister = async () => {
  if (!registerFormRef.value) return

  await registerFormRef.value.validate(async (valid) => {
    if (!valid) {
      ElMessage.warning('请完善注册信息')
      return
    }

    loading.value = true
    try {
      await authApi.register({
        username: form.username,
        password: form.password,
        school: form.school,
        phone: form.phone
      })
      
      // 保存注册信息以供登录页面自动免填填充
      localStorage.setItem('remembered_username', form.username)
      localStorage.setItem('remembered_password', form.password)

      ElMessage.success('注册成功，请登录')
      router.push('/login')
    } catch (error) {
      // API call failure will be handled by response interceptor / display ElMessage
    } finally {
      loading.value = false
    }
  })
}
</script>

<style scoped>
.register-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #eef2ff 0%, #e0f2fe 100%);
  padding: 20px;
}

.register-card {
  width: 100%;
  max-width: 420px;
  border-radius: 16px;
}

.card-header {
  text-align: center;
}

.card-header h2 {
  font-size: 22px;
  margin-bottom: 4px;
  color: #1f2937;
}

.card-header p {
  font-size: 14px;
  color: #6b7280;
}

.register-btn {
  width: 100%;
  margin-top: 8px;
}

.login-link {
  margin-top: 16px;
  text-align: center;
  font-size: 14px;
  color: #6b7280;
}

.register-system-title {
  font-size: 14px;
  margin-top: 4px;
  color: #6b7280;
}
.brand-love {
  background: linear-gradient(135deg, #ff4e50 0%, #f9d423 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 800;
  margin-right: 3px;
}
.brand-sub {
  color: #6b7280;
  font-weight: 600;
}
</style>
